import ICommand from "./ICommand";
import useMessageLogic from "../logic/useMessageLogic";
import {useAppSelector} from "../hooks";
import {Member} from "../api/Models";
import {selectMembers} from "../redux/members";

export const useMembersCommand = (): ICommand => {
  const members = useAppSelector(selectMembers)
  const messages = useMessageLogic()

  return {
    secure: true,

    help(): string {
      return '- m(embers)\t\t\t\t:: shows the members of the system';
    },

    async process(msg: string): Promise<void> {
      messages.addNoticeMessage('(' + members.length + ') ' + members.map((m: Member) => m.name).join(', '))
    },

    matches(msg: string): boolean {
      return ['m', 'members'].includes(msg.toLowerCase().trim())
    }
  };
}